import React from 'react';
import tw from 'twin.macro';
import SEO from '../components/seo';
import {
  Features,
  FeaturesBlocks,
  HeroHome,
  Newsletter,
  Testimonials,
} from '../modules/landing-page';

const Landing = ({ location }: { location: Record<string, any> }) => {
  return (
    <>
      <SEO
        title="Playflow"
        description="Bringing order to the chaos that is your Spotify library"
        keywords={[
          'spotify playlist',
          'organize playlist',
          'organize spotify',
          'magicplaylist',
        ]}
        location={location}
      />
      {/* <div tw="text-green-500">
          <h1 tw="text-6xl mb-4 font-black">Playflow</h1>
          <h4 tw="text-lg mb-4 font-light">
            Bringing order to the chaos that is your Spotify library.
          </h4>
          <h5 tw="text-xl">Yes, I&apos;m talking about you.</h5>
          <button type="button">Click me</button>
        </div> */}
      <main className="flex-grow">
        {/*  Page sections */}
        <HeroHome />
        {/* <Features /> */}
        {/* <FeaturesBlocks /> */}
        {/* <Testimonials /> */}
        {/* <Newsletter /> */}
      </main>
    </>
  );
};

export default Landing;
